import React, { useState, useEffect } from "react";
import { Tag, Space, Row, Col, Button, Checkbox, Input, Spin, Select, DatePicker, Form } from "antd";
import AppTable from "../../components/AppTable/AppTable";
import moment from 'moment-timezone';
import axiosGet from "../../helpers/AxiosRequest";
import { UrlConstants } from "../../helpers/UrlConstantsHelper";
import "../../pages/Booking/Booking.scss";
import "./Report.scss";
import AppModalCabAtdncReport from "../../components/AppModal/AppModalCabAtdncReport";
import { DownloadOutlined } from '@ant-design/icons';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const { Option } = Select;
const { Search } = Input;

const CabDayReport = () => {
  const [currentBookingGridData, setCurrentBookingGridData] = useState([]);
  const [cabatdmodalVisible, setcabatdmodalVisible] = useState(false);
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [branchid, setbranchid]: any = useState(localStorage.getItem("cityid"));
  const [SearchText, setsearchText]: any = useState("");
  const [copycurrentBookingGridData, setcopyCurrentBookingGridData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [ButtonClicked, setIsButtonClicked] = useState("Today");
  const [fromdate, setfromdate] = useState(moment());
  const [todate, settodate] = useState(moment());
  const dateFormat = "DD/MM/YYYY";
  const [selectedValues, setSelectedValues]: any = useState({});
  const [cabIdsList, setcabIdsList] = useState([]);
  const [vehicleIdsList, setvehicleIdsList] = useState([]);
  const [searchCabIdsList, setSearchCabIdsList] = useState([]);
  const [searchVehicleIdsList, setSearchVehicleIdsList] = useState([]);
  const [flag, setFlag] = useState(false);
  const [comissionamount, setComissionamount] = useState(0);
  const [emptykm, setEmptykm] = useState(0);
  const [tablelength, setTablelength] = useState(0);
  const [totalamount, setTotalamount] = useState(0);
  const [totalkm, setTotalkm] = useState(0);
  const [tripscount, setTripscount] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [pagination, setPagination]: any = useState({
    current: 1,
    pageSize: 100,
  });


  const columns = [
    { title: 'Cab ID', dataIndex: 'cab_id', key: 'cab_id' },
    {
      title:
        <div style={{ textAlign: 'center' }}>
          <div>Trips</div>
          <div style={{ fontWeight: 'bold', fontSize: '16px' }}>
            {tripscount}
          </div>
        </div>, dataIndex: 'rideCount', key: 'rideCount'
    },
    { title: 'Days', dataIndex: 'daysActive', key: 'daysActive' },
    {
      title: (
        <div style={{ textAlign: 'center' }}>
          <div>Fare</div>
          <div style={{ fontWeight: 'bold', fontSize: '16px' }}>
            {totalamount}
          </div>
        </div>
      ),
      dataIndex: 'totalFare',
      key: 'totalFare',
    },
    {
      title:
        <div style={{ textAlign: 'center' }}>
          <div>Eff. Km</div>
          <div style={{ fontWeight: 'bold', fontSize: '16px' }}>
            {totalkm}
          </div>
        </div>, dataIndex: 'effectkm', key: 'effectkm'
    },
    { title: 'Total Km', dataIndex: 'Total_km', key: 'Total_km' },
    { title: 'Cancelled', dataIndex: 'Cancelled', key: 'Cancelled' },
  ];

  const onfromdatechange = (value: any) => {
    setfromdate(value);
    try {

      var fromdate = moment(value).format("YYYY/MM/DD");
      let todate = moment().format("YYYY/MM/DD");

      setFlag(false);
    }
    catch (ex) {
      console.log(ex);
    }

  }
  const ontodatechange = (value: any) => {
    settodate(value);
    try {

      var todate = moment(value).add("days", 1).format("YYYY/MM/DD");
      let startdate = moment(fromdate).format("YYYY/MM/DD");
      //DateSearch(startdate, todate);
      setFlag(false);
    }
    catch (ex) {
      console.log(ex);
    }

  }

  const adayclick = (event: any = null) => {
    setIsButtonClicked('Today');
    var first = moment();
    var firstday = first.format('DD'); var firstmonth = first.format('MM'); var firstyear = first.format('YYYY');
    let fromdate = firstyear + '-' + firstmonth + '-' + firstday;
    setfromdate(moment(fromdate));
    //var new_date = moment().add('days', 1);
    var new_date = moment();
    var day = new_date.format('DD'); var month = new_date.format('MM'); var year = new_date.format('YYYY');
    let todate = year + '-' + month + '-' + day;
    settodate(moment(todate));
    setFlag(true);
    onTableSearch(fromdate, todate, pagination, SearchText);
  };

  const monthclick = () => {
    setIsButtonClicked('Month');
    var first = moment();
    var firstmonth = first.format('MM'); var firstyear = first.format('YYYY');
    let fromdate = firstyear + '-' + firstmonth + '-' + '01';
    setfromdate(moment(fromdate));
    //var new_date = moment().add('days', 1);
    var new_date = moment();
    var day = new_date.format('DD'); var month = new_date.format('MM'); var year = new_date.format('YYYY');
    let todate = year + '-' + month + '-' + day;
    settodate(moment(todate));
    console.log(fromdate);
    setFlag(true);
    onTableSearch(fromdate, todate, pagination, SearchText);
  };

  const weekclick = () => {
    setIsButtonClicked('Week');
    var first = moment().add('days', -(moment().day()))
    var firstday = first.format('DD'); var firstmonth = first.format('MM'); var firstyear = first.format('YYYY');
    let fromdate = firstyear + '-' + firstmonth + '-' + firstday;
    setfromdate(moment(fromdate));
    console.log(fromdate);
    //var new_date = moment().add('days', 1);
    var new_date = moment();
    var day = new_date.format('DD'); var month = new_date.format('MM'); var year = new_date.format('YYYY');
    let todate = year + '-' + month + '-' + day;
    settodate(moment(todate));
    setFlag(true);
    onTableSearch(fromdate, todate, pagination, SearchText);
  };
  const disabledDate = (current: any) => {
    // Can not select days before today and today
    return current && current > moment().endOf("day");
  };
  const disabledFromDate = (current: any) => {
    // Can not select days before today and today
    return (current && current > moment(todate).endOf("day"));
  };
  const onTableSearch = (fromdate: any, todate: any, pagination: any, SearchText: any) => {
    DateSearch(moment(fromdate).format("YYYY/MM/DD"), moment(todate).add("days", 1).format("YYYY/MM/DD"), pagination, SearchText);

  }

  const onTableClear = () => {
    selectedValues.cab_id = null;
    selectedValues.vehicleid = null;
    setSearchCabIdsList([]);
    setSearchVehicleIdsList([])
    /* let copyselectedvalues = { ...selectedValues };
    copyselectedvalues.cab_id=null;
  copyselectedvalues.vehicleid=null;
    setSelectedValues(copyselectedvalues); */
    //adayclick();
    onTableSearch(fromdate.format('YYYY/MM/DD'), todate.format('YYYY/MM/DD'), pagination, SearchText);
  }

  const DateSearch = (fromdate: any, todate: any, pagination: any, SearchText: any) => {
    setIsLoading(true);

    const options = {
      params: {
        branchid,
        fromdate,
        todate,
      },
    };

    axiosGet(UrlConstants.cabDayreport, options)
      .then((resp: any) => {
        const rawData = resp?.data?.data ?? [];

        const data = rawData.map((e: any) => ({
          ...e,
          key: e.cab_id, // Required by Ant Design or similar table libraries
        }));

        data.sort((a: any, b: any) => a.cab_id?.localeCompare(b.cab_id));

        setCurrentBookingGridData(resp.data);
        setcopyCurrentBookingGridData(resp.data);
        setTotalkm(resp.TotalDistance);
        setTripscount(resp.TotalTrips);
        setTotalamount(resp.TotalFare);

      })
      .catch((error: any) => {
        console.error("Error fetching cab report:", error.response?.data || error.message);
        setCurrentBookingGridData([]);
        setcopyCurrentBookingGridData([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };


  useEffect(() => {
    console.log(isRowSelected);
    getcabids();
    getvehicleids();
    adayclick();
  }, []);

  const onSearchchange = (e: any) => {
    setsearchText(e.target.value);
    globalSearch(e.target.value);
  };
  const globalSearch = (searchText: string) => {
    if (!currentBookingGridData || currentBookingGridData.length === 0) {
      setcopyCurrentBookingGridData([]);
      setFilteredData([]);
      return;
    }

    const lowerSearch = searchText.toLowerCase();

    const filteredData = currentBookingGridData.filter((value: any) => {
      return (
        (value.cab_id && value.cab_id.toString().toLowerCase().includes(lowerSearch))
      );
    });

    setcopyCurrentBookingGridData(filteredData);
    setFilteredData(filteredData);
  };
  const onVehicleIdChange = (value: any, fullInfo: any) => {
    let copyselectedvalues = { ...selectedValues };
    copyselectedvalues.vehicleid = value;
    setSelectedValues(copyselectedvalues);
  };
  const onCabIdChange = (value: any, fullInfo: any) => {
    let copyselectedvalues = { ...selectedValues };
    copyselectedvalues.cab_id = value;
    setSelectedValues(copyselectedvalues);
  };


  const getcabids = () => {
    const uri = UrlConstants.getcabidlist + "?CityId=" + branchid;
    axiosGet(uri).then((resp: any) => {
      console.log(resp);
      setcabIdsList(resp);
    });
  };
  const getvehicleids = () => {
    const uri = UrlConstants.getvehicleidslist + "?CityId=" + branchid;
    axiosGet(uri).then((resp: any) => {
      console.log(resp);
      setvehicleIdsList(resp);
    });
  };

  const onCabIdSearch = (value: any) => {
    if (value) {
      // const searchedList = locationsList.filter(
      //   (x: any) => x.PlaceName.toLowerCase().indexOf(value) > -1
      // );
      console.log(cabIdsList);

      var filtered = cabIdsList.filter((x: any) => String(x.cab_id?.toLowerCase()).includes(value.toLowerCase()));
      console.log(filtered);
      setSearchCabIdsList(filtered);
      /*  selectedValues.cab_id = '';
       selectedValues.vehicleid = ''; */
    } else {
      setSearchCabIdsList([]);
    }
  };

  const onVehicleIdSearch = (value: any) => {
    if (value) {
      // const searchedList = locationsList.filter(
      //   (x: any) => x.PlaceName.toLowerCase().indexOf(value) > -1
      // );
      var filtered = vehicleIdsList.filter((x: any) => String(x.vehicleid?.toLowerCase()).includes(value.toLowerCase()));
      //console.log(searchedList,filtered);
      setSearchVehicleIdsList(filtered);
    } else {
      setSearchVehicleIdsList([]);
    }
  };
  const onPaginationchange = (pagination: any, filters: any, sorter: any, extra: any) => {
    setPagination(pagination);
    onTableSearch(fromdate, todate, pagination, SearchText);
    console.log(pagination);
  }
  const onSearch = (value: any) => {
    console.log(value);
    setsearchText(value);
    onTableSearch(fromdate, todate, pagination, value);
  }
  const today = moment().format("DD-MM-YYYY");
  const exportToCSV = (data: any[], columns: any[], fileName = `Cab Day Report`) => {
    const exportData = data.map((row) => {
      const formattedRow: any = {};

      columns.forEach((col: any) => {
        const key = col.dataIndex;

        let columnTitle = '';
        if (typeof col.title === 'string') {
          columnTitle = col.title;
        } else if (typeof col.title === 'object' && col.title?.props?.children) {
          const children = col.title.props.children;
          const topLabel = Array.isArray(children) ? children[0] : children;
          columnTitle = typeof topLabel === 'string' ? topLabel : topLabel?.props?.children || '';
        }

        if (typeof key === 'string') {
          formattedRow[columnTitle.trim()] = row[key];
        }
      });

      return formattedRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const dataBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(dataBlob, `${fileName}.xlsx`);
  };


  return (
    <div className="booking-child-routes">
      <div className="booking-child-routes-button-section">
        <Row style={{ paddingBottom: 10 }}> <Col>  <span style={{ fontSize: 'large', fontWeight: 'bold', fontStyle: 'Times New Roman' }}> CAB DAY REPORT</span>
        </Col>
          <Col offset={2}>
            <span style={{ fontSize: 'large', fontWeight: 'bold', fontStyle: 'Times New Roman' }}> From : {moment(fromdate).format('DD.MM.YYYY')}   To : {flag ? moment().format('DD.MM.YYYY') : moment(todate).format('DD.MM.YYYY')}  </span>

          </Col></Row>
        <Row style={{ paddingBottom: 10 }}>

          <Col >

            <span style={{ fontSize: 'medium' }}> From:</span>

            <DatePicker

              value={fromdate}
              format={dateFormat}
              disabledDate={disabledFromDate}
              onChange={onfromdatechange} />
            <span style={{ fontSize: 'medium' }}> To:</span>


            <DatePicker
              value={flag ? moment() : todate}
              //value={todate}
              format={dateFormat}
              disabledDate={disabledDate}
              onChange={ontodatechange} />

          </Col>
          <Col span={2} offset={1}>
            <Button className={ButtonClicked === 'Today' ? "booking-btn-buttonTrue" : "booking-btn-buttonFalse"}
              onClick={adayclick}
            >
              Today
            </Button>
          </Col>
          <Col span={2} offset={1} >
            <Button className={ButtonClicked === 'Week' ? "booking-btn-buttonTrue" : "booking-btn-buttonFalse"}
              onClick={weekclick}
            >
              Week
            </Button>
          </Col>
          <Col span={2} offset={1}>
            <Button className={ButtonClicked === 'Month' ? "booking-btn-buttonTrue" : "booking-btn-buttonFalse"}
              onClick={monthclick}
            >
              Month
            </Button>
          </Col>

        </Row>
        <Row style={{ paddingBottom: '10px' }}>
          <Col span={3}>
            <Select placeholder="Cab Id"
              style={{ width: 100 }}
              showSearch
              optionFilterProp="children"
              value={selectedValues.cab_id}
              onChange={onCabIdChange}
              filterOption={(input: any, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              showArrow={false}
              onSearch={onCabIdSearch}
              notFoundContent={null}>

              {searchCabIdsList.map((id_: any) => (
                <Option key={id_.cab_id} value={id_.cab_id}>
                  {id_.cab_id}
                </Option>
              ))}
            </Select>
          </Col>
          <Col span={3}>
            <Select placeholder="Vehicle Id"
              value={selectedValues.vehicleid}
              style={{ width: 100 }}
              showSearch
              optionFilterProp="children"
              onChange={onVehicleIdChange}
              filterOption={(input: any, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              showArrow={false}
              onSearch={onVehicleIdSearch}
              notFoundContent={null}
            >

              {searchVehicleIdsList.map((id: any) => (
                <Option key={id.vehicleid} value={id.vehicleid}>
                  {id.vehicleid}
                </Option>
              ))}
            </Select>
          </Col>
          <Col span={2}>
            <Button
              onClick={() => onTableSearch(fromdate, todate, pagination, SearchText)}
              className="report-btn-blockSearch"
              disabled={moment(fromdate).isAfter(moment(todate))}>
              Search
            </Button>
          </Col>
          <Col span={2}>
            <Button
              htmlType="button"
              style={{ marginLeft: 10 }}
              className="report-btn-blockClear"
              onClick={onTableClear}>
              Clear
            </Button>
          </Col>
          <Col span={2} offset={2}>
            <Button
              className="report-btn-blocksms">
              Send sms
            </Button>
          </Col>
          <Col span={2} offset={1}>
            <Button icon={<DownloadOutlined />} type="primary" onClick={() => exportToCSV(copycurrentBookingGridData, columns)}>
            </Button>
          </Col>
          <Col span={3} offset={1}>
            <Input
              placeholder="Search Text"
              className="search"
              onChange={onSearchchange}
            />
          </Col>
        </Row>
        <Spin tip="Loading..." spinning={isLoading}>
          <AppTable
            columns={columns}
            data={copycurrentBookingGridData}
            enablePagination={pagination}
            onchange={onPaginationchange}
            scroll={{ x: "max-content" }}
          ></AppTable>
        </Spin>
      </div>
    </div>
  );
};

export default CabDayReport;
